import React, {useEffect, useRef} from 'react';
import ReactSignatureCanvas from 'react-signature-canvas';
import { Controller, useFormContext } from 'react-hook-form';
import { Button } from 'carbon-components-react';

const FormSignature = ({name, label}) => {
    const {formState, setValue, control} = useFormContext(); 

    const signaturePad = useRef(null);
    const parentOfPad = useRef(null);
    let obj = formState.errors[name];

    const array = name.substr(0, name.indexOf("["));
    if(array.length > 0){
        const optionalName = name.replace('.', '?.');
        obj = formState.errors[array] ? eval(`formState.errors.${optionalName}`) : null;
    }

    const formatIntoPng = () => {
        if (signaturePad.current) {
          const dataURL = signaturePad.current.getTrimmedCanvas().toDataURL();
          return dataURL;
        }
      };
      const clearSignature = () => {
        setValue('signature', null);

        signaturePad.current.clear();
      }

    useEffect(() => {
        signaturePad.current.getCanvas().width = parentOfPad.current.offsetWidth - 8;

        let timeoutId = null;
        const resizeListener = () => {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            var current = signaturePad.current;
            const canvas = current.getCanvas();
            canvas.width = parentOfPad.current.offsetWidth-8;
          }, 150);
        };
        window.addEventListener('resize', resizeListener);
    
        // clean up function
        return () => {
          window.removeEventListener('resize', resizeListener);
        }

    },[])

    return ( 
        <>
            <div className="grid grid-cols-2 items-center mt-2">
                <span>{label}</span>
                <span className="justify-self-end">
                <Button size="sm" kind="ghost" onClick={clearSignature}>Clear</Button>
                </span>
            </div>
            <div ref={parentOfPad} className={formState.errors?.signature?.message ? 'border border-red-700 border-solid': 'border border-slate-400 border-solid'}>
                <Controller control={control} name={name} render={
                    ({field}) => (<ReactSignatureCanvas ref={signaturePad}  onEnd={() => field.onChange(formatIntoPng())} penColor="#333"  canvasProps={{height:"200"}} />)
                } />
            </div>
            {!!obj ? <div className='text-danger my-2'>{obj?.message}</div> :<></>}

        </>
     );
}
 
export default FormSignature;